module.exports = __webpack_public_path__ + "img/t2-25.ac3d19e5.svg";